import { createReducer, on } from '@ngrx/store';

import { ELIGIBLE_PROMOTIONS_STORE_API_ACTIONS } from './eligible-promotions.action';
import {
  ELIGIBLE_PROMOTIONS_STORE_INITIAL_STATE,
  EligiblePromotionsState,
} from './eligible-promotions.state';

export const ELIGIBLE_PROMOTIONS_STORE_REDUCER = createReducer(
  ELIGIBLE_PROMOTIONS_STORE_INITIAL_STATE,

  on(
    ELIGIBLE_PROMOTIONS_STORE_API_ACTIONS.loadEligiblePromotionsLoading,
    (state): EligiblePromotionsState => ({
      ...state,
      // Drop the previous shop's promotions as soon as a new request starts.
      data: [],
      isLoading: true,
      hasError: false,
      error: null,
    }),
  ),

  on(
    ELIGIBLE_PROMOTIONS_STORE_API_ACTIONS.loadEligiblePromotionsSuccess,
    (state, { data }): EligiblePromotionsState => ({
      ...state,
      data: data ?? null,
      isLoading: false,
      isLoaded: true,
      hasError: false,
      error: null,
    }),
  ),

  on(
    ELIGIBLE_PROMOTIONS_STORE_API_ACTIONS.loadEligiblePromotionsFailure,
    (state, { error }): EligiblePromotionsState => ({
      ...state,
      isLoading: false,
      hasError: true,
      error,
    }),
  ),
);
